module.exports = __webpack_public_path__ + "img/creditCard.5ac6df2c.svg";